import { styled } from '@creditas-ui/system'
import { salaryAdvanceBox } from './salaryAdvanceBox.style'

const SalaryAdvanceBox = styled.div`
  ${salaryAdvanceBox}
`

export { SalaryAdvanceBox }
